var React = require('react');
var objectAssign = require('object-assign');
module.exports = function (props) {
    return React.createElement('svg', objectAssign({}, {
        viewBox: '0 0 14 15',
        version: '1.1'
    }, props), React.createElement('title', null), React.createElement('defs', null), React.createElement('g', {
        id: 'Projects',
        stroke: 'none',
        strokeWidth: '1',
        fill: 'none'
    }, React.createElement('g', {
        id: 'Account-Popup',
        transform: 'translate(-297.000000, -377.000000)'
    }, React.createElement('g', {
        id: 'Private-Icon',
        transform: 'translate(297.000000, 378.000000)'
    }, React.createElement('rect', {
        id: 'Rectangle-80',
        fill: '#D0D0D0',
        x: '0',
        y: '7',
        width: '14',
        height: '7',
        rx: '2'
    }), React.createElement('path', {
        d: 'M11,4 C11,1.791 9.209,0 7,0 C4.791,0 3,1.791 3,4 L3,7.5',
        id: 'Stroke-2',
        stroke: '#D0D0D0',
        strokeWidth: '2'
    })))));
};


//////////////////
// WEBPACK FOOTER
// ./~/react-icon-loader!./app/images/PermissionUnlisted.svg
// module id = 531
// module chunks = 1